import { useContext } from 'react'
import { IconComponent } from 'ui'
import { UGEContext } from '../../../context'
import { gradientFromEditor, iconFromEditor } from '../../../utilities/editor'
import { Alert, Button } from './style'

type Props = {
    className?: string
}

const UGEDefaultEditorNoAnimation = ({ className }: Props) => {
    const { duration, openEditor } = useContext(UGEContext)

    function onFiltersClick() {
        openEditor('filters')
    }

    function onStickersClick() {
        openEditor('stickers')
    }

    if (duration > 0) {
        return null
    }

    return (
        <Alert
            className={className}
            description="GIFs must be in motion. Apply a filter or sticker (or both) to animate your image."
            title="This is a still image!"
        >
            <Button color="#000" size="medium" onClick={onFiltersClick}>
                Add Filter
                <IconComponent
                    gradient={gradientFromEditor('filters')}
                    height={20}
                    icon={iconFromEditor('filters')}
                    width={20}
                />
            </Button>
            <Button color="#000" size="medium" onClick={onStickersClick}>
                Add Stickers
                <IconComponent
                    gradient={gradientFromEditor('stickers')}
                    height={20}
                    icon={iconFromEditor('stickers')}
                    width={20}
                />
            </Button>
        </Alert>
    )
}

export default UGEDefaultEditorNoAnimation
